module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.platformClass,
    attrs: {
      "id": "app"
    }
  }, [_c('f7-statusbar'), _vm._v(" "), _c('left-panel-view'), _vm._v(" "), _c('f7-views', [_c('f7-view', {
    attrs: {
      "url": "/",
      "init": true,
      "id": "main-view",
      "dynamic-navbar": true,
      "navbar-through": "",
      "main": ""
    }
  }, [(_vm.isiOS) ? _c('f7-navbar', [_c('f7-nav-left', [_c('f7-link', {
    attrs: {
      "icon": "icon-bars",
      "open-panel": "left"
    }
  })], 1), _vm._v(" "), _c('f7-nav-center', [_vm._v("\n          Home\n        ")])], 1) : _vm._e(), _vm._v(" "), _c('f7-pages', [_c('home-page')], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5f24868a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 326
// module chunks = 2